module.exports = __webpack_public_path__ + "media/images/fallback_audio-6a1f7018e64e9570e14111dd54ed698e.png";